export default [
	{
		path: '/mallStore',
		name: 'MallStore',
		redirect: '/mallStore/index',
		component: () => import('@/views/mallStore/index.vue'),
		meta: { title: '应用商城', whiteListed: false },
		children: [
			{
				path: 'index',
				name: 'MallStoreHome',
				component: () => import('@/views/mallStore/home.vue'),
				meta: { title: '服务商城', whiteListed: true }
			},
			{
				path: 'goods/self/:id',
				name: 'MallStoreSelfGoodsDetail',
				component: () => import('@/views/mallStore/selfGoodsDetail.vue'),
				meta: { title: '自营商品详情', whiteListed: true }
			},
			{
				path: 'goods/exhibition/:id',
				name: 'MallStoreExhibitionGoodsDetail',
				component: () => import('@/views/mallStore/exhibitionGoodsDetail.vue'),
				meta: { title: '展销商品详情', whiteListed: true }
			},
			{
				path: 'payment',
				name: 'MallStorePayment',
				component: () => import('@/views/mallStore/payment.vue'),
				meta: { title: '订单支付', whiteListed: false }
			},
			{
				path: 'purchase',
				name: 'MallPurchase',
				component: () => import('@/views/mall/purchase/index.vue'),
				meta: { title: '购买流程', whiteListed: false }
			},
			{
				path: 'goods-signature/:id',
				name: 'MallGoodsSignature',
				component: () => import('@/views/mall/goodsDetail/goodsSignature.vue'),
				meta: { title: '商品详情', whiteListed: true }
			},
			{
				path: 'goods-propaganda/:id',
				name: 'MallGoodsPropaganda',
				component: () => import('@/views/mall/goodsDetail/goodsPropaganda.vue'),
				meta: { title: '商品详情', whiteListed: true }
			},
			{
				path: 'goods-corporate/:id',
				name: 'MallGoodsCorporate',
				component: () => import('@/views/mall/goodsDetail/goodsCorporate.vue'),
				meta: { title: '商品详情', whiteListed: true }
			},
			{
				path: 'goods-customized/:id',
				name: 'MallGoodsCustomized',
				component: () => import('@/views/mall/goodsDetail/goodsCustomized.vue'),
				meta: { title: '商品详情', whiteListed: true }
			}
		]
	}
]
